import { getApiActionTypes } from '../storeHelpers';

export const fetchPdfAttachmentsTypes = getApiActionTypes('FETCH_PDF_ATTACHMENTS');
export const fetchPdfImageTypes = getApiActionTypes('FETCH_PDF_IMAGE');
export const updateOrDeletePdfAttachmentsTypes = getApiActionTypes(
  'UPDATE_OR_DELETE_PDF_ATTACHMENTS',
);
export const createPdfAttachmentTypes = getApiActionTypes('CREATE_PDF_ATTACHMENT');
export const fetchBinderAttachmentTypes = getApiActionTypes('FETCH_BINDER_ATTACHMENT');
